var React = require('react');

function Siren (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m0 241h61v30h-61zm0 0","key":0}),React.createElement("path",{"d":"m451 241h61v30h-61zm0 0","key":1}),React.createElement("path",{"d":"m383.277344 107.511719 42.421875-42.421875 21.210937 21.210937-42.421875 42.421875zm0 0","key":2}),React.createElement("path",{"d":"m107.507812 128.71875-42.421874-42.421875 21.210937-21.210937 42.421875 42.421874zm0 0","key":3}),React.createElement("path",{"d":"m241 0h30v61h-30zm0 0","key":4}),React.createElement("path",{"d":"m121 452c-16.570312 0-30 13.429688-30 30v30h330v-30c0-16.570312-13.429688-30-30-30zm0 0","key":5}),React.createElement("path",{"d":"m121 256v166h270v-166c0-74.441406-60.558594-135-135-135s-135 60.558594-135 135zm120-45h30v90h-30zm0 120h30v30h-30zm0 0","key":6})]);
}

Siren.defaultProps = {"height":"512pt","viewBox":"0 0 512 512","width":"512pt"};

module.exports = Siren;

Siren.default = Siren;
